'use strict';

module.exports = String.fromCharCode;


// WEBPACK FOOTER //
// ./~/sugar-date/common/var/chr.js